'use client';

import { c as _c } from "react/compiler-runtime";
import { useDeviceStore } from '@/store/about/deviceStore';
import { useInquiryModal } from '../_hooks/useInquiryModal';
import { useScrollY } from '../_hooks/useScrollY';
export default function InquiryButton(t0) {
  const $ = _c(10);
  const {
    position
  } = t0;
  const deviceType = useDeviceStore(_temp);
  const {
    inquiryModal
  } = useInquiryModal();
  const scrollPosition = useScrollY();
  if (position === "top-banner") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <i className="icon_arrow" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== inquiryModal) {
      t2 = <button className="btn_inquiry" type="button" onClick={inquiryModal}>이실장 상담문의 바로가기 {t1}</button>;
      $[1] = inquiryModal;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (position === "header") {
    if (deviceType === "desktop" && scrollPosition > 0 || deviceType === "mobile") {
      let t1;
      if ($[3] !== deviceType) {
        t1 = deviceType === "desktop" ? <>이실장 상담문의 <i className="icon_arrow" /></> : "\uC0C1\uB2F4\uBB38\uC758";
        $[3] = deviceType;
        $[4] = t1;
      } else {
        t1 = $[4];
      }
      let t2;
      if ($[5] !== inquiryModal || $[6] !== t1) {
        t2 = <button className="btn_primary sm" type="button" onClick={inquiryModal}>{t1}</button>;
        $[5] = inquiryModal;
        $[6] = t1;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      return t2;
    }
  }
  if (position === "inquiry") {
    let t1;
    if ($[8] !== inquiryModal) {
      t1 = <button className="btn btn_rounded_primary xl" type="button" onClick={inquiryModal}>이실장 상담문의 바로가기</button>;
      $[8] = inquiryModal;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  return null;
}
function _temp(state) {
  return state.deviceType;
}